import { validate } from '@krugom/validator';
import { TValidationScheme } from '@krugom/validator/dist/types';

const scrollTo = (arg?: any) => {
  const scheme: TValidationScheme = {
    type: 'string',
    required: true,
  };
  const result = validate(arg, scheme);

  if (!result.isValid) return;
  const blockDiv = document.getElementById(arg);
  if (!blockDiv) {
    console.error(`HTML element with id "${arg}" not found!`);
    return;
  }
  blockDiv.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};

export default scrollTo;
